import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { FeaturesOverviewComponentSkeleton } from "../../..";

// styles
import useStyles from "./styles";

const AmenitiesFacilitiesComponentSkeleton = ({isLoadingPropertiesDetailes}) => {
  const styles = useStyles();
  return (
    <Box className={styles.wrapperAmenitiesFacilitiesComponent}>
      <Box className={styles.containerHeader}>
        <Skeleton variant="text" width={50} height={24} />
        <Skeleton variant="text" width={50} height={24} />
      </Box>
      <Box className={styles.cardWapper}>
        {[...Array(2)].map((_, index) => (
          <FeaturesOverviewComponentSkeleton key={index} />
        ))}
      </Box>
    </Box>
  );
};

export default AmenitiesFacilitiesComponentSkeleton;
